import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib';
import { fieldVariants } from './fieldStyles';

export interface InputProps
  extends Omit<ComponentProps<'input'>, 'size'>,
    VariantProps<typeof fieldVariants> {}

export function Input({ className, size, type = 'text', ...props }: InputProps) {
  return <input type={type} className={cn(fieldVariants({ size }), className)} {...props} />;
}
